<template>
    <div class="container">
        <i :style="'color:'+color" class="iconfont icon-zanwuxinxi"></i>
        <div :style="'color:'+color" class="text">{{title}}</div>
    </div>
</template>

<script>
    export default {
        name: "loading",
        props: {
            title: {
                type: String,
                default: "暂无内容"
            },
            color:{
                type:String,
                default:"#717171",
            }
        }
    }
</script>

<style scoped lang="less">
    .container {
        text-align: center;
        padding-top: 30px;
        i {
            font-size: 40px;
        }
        .text {
            font-size: 14px;
            padding: 10px;
        }
    }

    @keyframes loading {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>